import React, { useMemo, useState } from 'react';
import { Button } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../custom-components/menu/Sidebar';
import { PATHS } from '../../router/routes';
import { Menu } from 'lucide-react';

const DesktopContainer = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const location = useLocation();

    const pageTitle = {
        [PATHS.MY_AGENT]: 'My Agent',
        [PATHS.CALL_ACTIVITY]: 'Call Activity',
        [PATHS.AUTOMATION_TEMPLATE]: 'Integrations',
        [PATHS.PROFILE_INFO]: 'Profile',
        [PATHS.PROFILE_PASSWORD]: 'Profile',
        [PATHS.API_KEY]: 'Profile',
        [PATHS.SUBSCRIPTION]: 'Subscription',
    };

    const { isMyAgentPage, isRouteWithWhiteBg } = useMemo(() => {
        return {
            isMyAgentPage: location.pathname.includes(PATHS.MY_AGENT),
            isRouteWithWhiteBg: location.pathname.includes(PATHS.CALL_ACTIVITY.split('/')[1]),
        };
    }, [location.pathname]);

    return (
        <>
            <div className='min-h-screen bg-gray-50 flex'>
                <Sidebar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
                <main className={`flex-1 lg:ml-64 p-4 max-w-full ${isRouteWithWhiteBg ? 'bg-white' : ''} `}>
                    <div className={`${isMyAgentPage ? 'max-w-5xl' : ''}  mx-auto`}>
                        <header className='flex justify-between items-center mb-4'>
                            <h1 className='text-2xl font-bold text-[#050536]'>{pageTitle[location.pathname]}</h1>
                            <div className='flex justify-end lg:hidden'>
                                <Button variant='ghost' size='icon' onClick={() => setIsMenuOpen(true)}>
                                    <Menu className='h-6 w-6' />
                                </Button>
                            </div>
                        </header>
                        {children}
                    </div>
                </main>
            </div>
        </>
    );
};

export default DesktopContainer;
